import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';

@inheritSerialization(Entity)
export class Zone extends Entity {

  @deserializeAs('in_perimetre_propection_monument_historique')
  inPerimetrePropectionMonumentHistorique;

  @deserializeAs('monument_historique')
  monumentHistorique;

  @deserializeAs('in_zone_risque_technologique')
  inZoneRisqueTechnologique;

  @deserializeAs('in_zone_risque_naturel_previsible')
  inZoneRisqueNaturelPrevisible;

  @deserializeAs('zone_sismicite')
  zoneSismicite;

  @deserializeAs('zone_climatique')
  zoneClimatique;

  @deserializeAs('in_zone_inondable')
  inZoneInondable;

  @deserializeAs('in_zone_potentiel_radon')
  inZonePotentielRadon;

}
